export default "__VITE_ASSET__aE26pI1p__"